import axios from "@/api/axiosInstance";
import { FetchProductsHistoryReportCategoriesResponse } from "./types";

export const fetchProductsHistoryReportCategories =
  async (): Promise<FetchProductsHistoryReportCategoriesResponse> => {
    const response =
      await axios.get<FetchProductsHistoryReportCategoriesResponse>(
        "/api/private/reports/products-history/categories",
      );
    return response.data;
  };
